


import { GlobalProvider, WorkerTasksComponentRef, UploadComponentRef, SideBarRef} from './utils/globalprovider.js';

import SideBar from "./components/siderbar/Sidebar.js"

import AppLogin from "./applications/appcode/applogin.js"
import AppLocal from './applications/appcode/applocal.js';
import App2 from './applications/testpages/App2';
import AppTranscription from './applications/appcode/apptranscription.js';
import AppSubtitle from './applications/appcode/appsubtitles.js';
import AppAd from './applications/appcode/appad.js';
import AppExports  from './applications/appcode/appexports.js';
import AppAllSettings from './applications/appcode/appallsetting.js';

import AppTests from './applications/appcode/appTests.js';
import Upload from "./upload/upload.js"
import WorkerTasks from './workertasks/workertasks.js';


import {getCurrentUserDatas, setCurrentUserDatas} from "./utils/software.js"

import { initlocalhost } from './utils/apis.js';

import { GlobalContext } from './utils/globalprovider';


import React from "react";
import SimplePopup from './components/bases/popup/simplePopup.js';
class App extends React.Component
{

    static contextType = GlobalContext;
    
    constructor (props)
    {
        super(props);
        initlocalhost();

        this.state = {
          currentAppName: "home",
          version: 0,

          };
        this.onNavigate = this.onNavigate.bind(this);
        this.checkIfCanCloseElement = this.checkIfCanCloseElement.bind(this);
        this.currentApp = React.createRef();
        
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.onNavigateWithSidebarState = this.onNavigateWithSidebarState.bind(this)

        const userdatas = getCurrentUserDatas();
        userdatas.id = 0;
        setCurrentUserDatas(userdatas);
          
        

    }  

    
    componentDidMount() {
      // Ajoute un écouteur à l'événement beforeunload lorsque le composant est monté


      window.addEventListener('beforeunload', this.handleBeforeUnload);


  };

  
    componentWillUnmount() {
      // Supprime l'écouteur lorsqu'on démonte le composant
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }
  
    handleBeforeUnload = (event) => {
      // Message d'avertissement à afficher
      
      
      // if(this.currentApp.current.canClose()) return;
      if (this.state.currentAppName==="home") return;

      const confirmationMessage = 'EasyTT -  Êtes-vous sûr de vouloir quitter cette page ? Les modifications non enregistrées seront perdues.';
  
      event.preventDefault();
      event.returnValue = confirmationMessage; // Certains navigateurs nécessitent cette ligne
      return confirmationMessage; // Pour compatibilité avec certains anciens navigateurs
    };



    onNavigateWithSidebarState(sidebarstate)
    {
      
      switch (sidebarstate)
      {
          case "login":
            this.onNavigate("localprojects");
            SideBarRef.current.setMenuState("login");
            break;

          case "transcription":
            this.onNavigate("transcription");
            SideBarRef.current.setMenuState("transcription");
            break;

          case "subtitles":
            
            this.onNavigate("subtitles");
            SideBarRef.current.setMenuState("subtitles");
            break;

            case "logout":

            if (!this.checkIfCanCloseElement()) 
              return;
            this.onNavigate("");
            SideBarRef.current.setMenuState("logout");
            break;
          case "local":
            if (!this.checkIfCanCloseElement()) 
              return;
            this.onNavigate("localprojects");
            SideBarRef.current.setMenuState("local");
            break;
      }

    }

    onNavigate(route)
    {
        
        this.setState ({currentAppName: route, version: this.state.version + 1});   
        
    }


  

  checkIfCanCloseElement()
  {
    return this.currentApp.current.canClose();
  }
  

  

  render ()
  {


    
    var element;


    
    switch (this.state.currentAppName)
    {
      default: element =  (<AppLogin ref={this.currentApp} onnavigate={this.onNavigateWithSidebarState}/>) ; break; // home
      case "localprojects": element =  (<AppLocal ref={this.currentApp} onnavigate={this.onNavigateWithSidebarState} /> ) ; break;
      case "transcription": element =  (<AppTranscription ref={this.currentApp} onnavigate={this.onNavigateWithSidebarState} key={this.state.version}/>); break;
      case "subtitles": element =  (<AppSubtitle ref={this.currentApp} onnavigate={this.onNavigateWithSidebarState} key={this.state.version} />); break;
      case "audiodescription": element =  (<AppAd ref={this.currentApp} onnavigate={this.onNavigateWithSidebarState} />); break;
      case "exports": element =  (<AppExports ref={this.currentApp} onnavigate={this.onNavigateWithSidebarState} />); break;
      case "settings": element =  (<AppAllSettings ref={this.currentApp} onnavigate={this.onNavigateWithSidebarState} />); break;
      case "tests": element =  (<AppTests ref={this.currentApp} onnavigate={this.onNavigateWithSidebarState} />); break;
    }


  
  
    return (

      

      <>



      
      <GlobalProvider>


      <SideBar ref = {SideBarRef} onNavigate = {this.onNavigate} onCheckCanClose = {this.checkIfCanCloseElement}>
      {element}
      </SideBar>
      <Upload visible={false} ref={UploadComponentRef}/>
      <WorkerTasks visible={false} ref={WorkerTasksComponentRef}/>
      </GlobalProvider>
      </>
      )
    }
}

export default App;
